import Vue from 'vue'

const Bus=new Vue();
export default Bus;




// WEBPACK FOOTER //
// ./src/components/TreeTable/bus.js